import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SwUpdateService {
  private updateAvailableSubject = new BehaviorSubject<boolean>(false);
  public updateAvailable$ = this.updateAvailableSubject.asObservable();

  constructor(private swUpdate: SwUpdate) {
    if (swUpdate.isEnabled) {
      this.checkForUpdates();
      this.handleUpdates();
    }
  }

  /**
   * Check for updates manually
   */
  public checkForUpdates(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate().then(() => {
        console.log('Checking for updates...');
      }).catch(err => {
        console.error('Error checking for updates:', err);
      });
    }
  }

  /**
   * Handle available updates
   */
  private handleUpdates(): void {
    // Listen for available updates (Angular 6 compatible)
    this.swUpdate.available.subscribe(event => {
      console.log('New version available:', event);
      this.updateAvailableSubject.next(true);
    });

    // Listen for activated updates
    this.swUpdate.activated.subscribe(event => {
      console.log('New version activated:', event);
    });
  }

  /**
   * Activate the update (reload the page)
   */
  public activateUpdate(): void {
    console.log('Activating update...');
    if (this.swUpdate.isEnabled) {
      this.swUpdate.activateUpdate().then(() => {
        // Force reload the page
        window.location.reload();
      }).catch(err => {
        console.error('Error activating update:', err);
      });
    }
  }
}
